<template>
	<div>
		<TextTemp :data="privacy" />
	</div>
</template>

<script>
	import TextTemp from './TextTemp'
	export default {
		name: 'Privacy',
		components: {
			TextTemp,
		},
		data() {
			return {
				privacy: {
					title: '隐私声明',
					abstract: [
						'MoPaaS（魔泊云）致力于保护您的隐私信息和信息安全。MoPaaS将对用户所提供的资料尽最大努力进行严格的管理及保护， 本站将使用相应的技术，防止您的个人资料丢失、被盗用或遭篡改。此隐私声明描述了MoPaaS对收集信息的使用和MoPaaS 网站隐私保护措施。'
					],
					item: [{
						title: '收集的信息',
						content: ['当您在MoPaaS网站上注册或请求其他信息时，您必须提供基本联系信息。', '当您购买MoPaaS应用或服务（以下称为“服务”）时，您必须提供开票信息。',
							'MoPaaS为改进服务，会使用相关技术收集用户与网站等的相关互动信息。'
						]
					}, {
						title: '信息的使用',
						content: ['MoPaaS使用所收集的信息为您提供您需要的产品和服务。', 'MoPaaS可能会使用所收集的信息向您提供有关MoPaaS的服务、合作伙伴、促销活动和事件的其他信息。',
							'为改进MoPaaS网站和服务，MoPaaS可能会使用所收集的信息，也可能会与代表MoPaaS工作的其他公司共享所收集的信息。',
							'MoPaaS保留面向免费用户刊载广告的权利，这些广告刊载过程中将可能使用必要的定向技术来提高广告相关度。', '在未得到您的许可之前，MoPaaS不会与无关的第三方共享、销售、出租或交易个人可识别信息。'
						]
					}, {
						title: '客户资料',
						content: ['MoPaaS的客户可向MoPaaS的服务部提交电子格式的资料或信息。', '除非在MoPaaS服务条款中有规定，或出于法律需要，否则MoPaaS不会查看、共享、分发或引用任何此类客户资料。',
							'只在出于提供服务、防止或解决服务及技术问题、应客户要求解决有关客户支持问题的目的时，或者出于法律需要时， MoPaaS可访问客户数据。'
						]
					}, {
						title: '信息安全',
						content: [
							'MoPaaS采用了一些现今最新的网络安全技术。当您使用行业标准安全技术访问我们的站点时，我们使用服务器身份验证和数据加密保护您的信息，并确保您的数据安全且仅对组织内的注册用户可用。竞争对手根本无法访问您的数据。',
							'用户每次登录时，必须输入MoPaaS为其提供的唯一用户名和密码。MoPaaS可能用“cookie”会话来记录特定会话过程中的加密身份验证信息。但会话 “cookie” 中不包含用户的用户名和密码。',
							'此外，MoPaaS托管于安全服务器环境中，该环境使用防火墙和其他一些先进技术来阻止外部入侵者的干扰或访问。'
						]
					}, {
						title: '隐私声明的更改',
						content: [
							'MoPaaS保留更改此隐私声明的权利。本隐私声明也适用任何用以增强或强化当前服务的新功能，包括发布新的工具和资源。 继续使用本服务的任何更改的服务后，表示您同意这种变化。MoPaaS可能对本文件的内容做的任何改变只发布在这里。 MoPaaS将根据诚信，常识，及合理的判断自行决定执行和解释本条款和条件。',
							'关于MoPaaS隐私声明或信息实践的问题， 请联系我们：mopaas@anchora.me'
						]
					}]
				}
			}
		}
	}
</script>

<style>
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/Privacy.vue